import React from 'react';  
import classNames from 'classnames/bind';
// import isEmpty from 'lodash.isempty';
import {translate} from 'utils/common';
class Icon extends React.Component {
  render() {
    return (<span></span>
      // <svg viewBox="0 0 20 20">
      //     <path d="M10,0.982c4.973,0,9.018,4.046,9.018,9.018S14.973,19.018,10,19.018S0.982,14.973,0.982,10
      //       S5.027,0.982,10,0.982 M10,0C4.477,0,0,4.477,0,10c0,5.523,4.477,10,10,10s10-4.477,10-10C20,4.477,15.523,0,10,0L10,0z M9,5.703
      //       V5.441h2.5v0.262l-0.66,5.779H9.66L9,5.703z M9.44,12.951h1.621v1.491H9.44V12.951z"/>
      //     </svg>
    )
  }
}
class PasswordValidator extends React.Component {
    constructor(props) {
        super(props);
        this.state={ 
            value: null,
            //minCharacters: this.props.minCharacters,
            // requireCapitals: this.props.requireCapitals,
            //requireNumbers: this.props.requireNumbers,
            forbiddenWords: this.props.forbiddenWords,
            name: this.props.name}
    }

    render(){ 
        var validatorClass = classNames({
          'password_validator tooltip fade bs-tooltip-right show':   true,
          'd-block':              this.props.visible,
          'd-none':            !this.props.visible
        });
    
        var forbiddenWords = this.state.forbiddenWords.map(function(word, i) {
          return (
            <span key={i} className="bad_word">
              "{word}"
            </span>
          )
        })
    
        var validatorTitle;
    
        if(this.props.valid) {
          validatorTitle = 
            <h4 className="validator_title valid">
              {/* {this.props.name+' '+translate('looks_good')} */}
              {translate('looks_good')}
            </h4>
        } else {
          validatorTitle = 
            <h4 className="validator_title invalid">
              {translate('password_rules')}
            </h4>
        }
    
        return (
          <div className={validatorClass}>
          <div className="arrow"></div>
            <div className="validator_container tooltip-inner">
    
              {validatorTitle}
    
              <ul className="rules_list">
            
                {this.props.minCharacters && <li className={classNames({'valid': this.props.validData.minChars})}> 
                  <i className="icon_valid far fa-check-circle"></i>
                  <i className="icon_invalid far fa-times-circle"></i>
                  
                  <span className="error_message">{translate('password_validate_minchar').replace('{0}', this.props.minCharacters)}</span>
                </li>}
    
                {this.props.requireCapitals && <li className={classNames({'valid': this.props.validData.capitalLetters})}> 
                  <i className="icon_valid far fa-check-circle"></i>
                  <i className="icon_invalid far fa-times-circle"></i>
                  
                  <span className="error_message">{translate('password_validate_capital').replace('{0}', this.props.requireCapitals)}</span>
                </li>}
                {this.props.requireWords && <li className={classNames({'valid': this.props.validData.words})}> 
                  <i className="icon_valid far fa-check-circle"></i>
                  <i className="icon_invalid far fa-times-circle"></i>
                  
                  <span className="error_message">{translate('password_validate_alphabet').replace('{0}', this.props.requireWords)}</span>
                </li>}
    
                {this.props.requireNumbers && <li className={classNames({'valid': this.props.validData.numbers})}> 
                  <i className="icon_valid far fa-check-circle"></i>
                  <i className="icon_invalid far fa-times-circle"></i>
                  <span className="error_message">{translate('password_validate_number').replace('{0}', this.props.requireNumbers)}</span>
                </li>}
    
                {/*<li className={classNames({'valid': this.props.validData.specialCharacters})}> 
                  <i className="icon_valid far fa-check-circle"></i>
                  <i className="icon_invalid far fa-times-circle"></i>
                  <span className="error_message">{translate('password_validate_specialchar').replace('{0}', 1)}</span>
                </li>*/}
                {/* <li className={classNames({'valid': this.props.validData.words})}> 
                  <i className="icon_valid far fa-check-circle"></i>
                  <i className="icon_invalid far fa-times-circle"></i>
                  <span className="error_message">Can't be {forbiddenWords}</span>
                </li> */}
              </ul>
            </div>
          </div>
        )
      }
}
export default PasswordValidator; 
